import React from 'react';
import moment from 'moment';
import Datagrid from '../../../../UI/Datagrid';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';

function Summary({ t, ...props }) {
  const columns = [
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      headerStyle: { width: '30%' },
    },
    {
      dataField: 'avgValue',
      text: 'Avg Value',
      sort: true,
      formatter: (cell, row) => `${row.avgValue} ${row.units}`,
    },
    {
      dataField: 'units',
      text: 'Avg Units',
      sort: true,
      hidden: true,
    },
    {
      dataField: 'minValue',
      text: 'Min Value',
      sort: true,
      formatter: (cell, row) => `${row.minValue} ${row.units}`,
    },
    {
      dataField: 'timeStampMin',
      text: 'Min Time',
      sort: true,
      isDateTime: true,
      headerStyle: { width: 150 },
    },
    {
      dataField: 'maxValue',
      text: 'Max Value',
      sort: true,
      formatter: (cell, row) => `${row.maxValue} ${row.units}`,
    },
    {
      dataField: 'timeStampMax',
      text: 'Max Time',
      sort: true,
      isDateTime: true,
      headerStyle: { width: 150 },
    },
    {
      dataField: 'sum',
      text: props.configure.group.calculatedValueHeading
        ? props.configure.group.calculatedValueHeading
        : 'Total',
      sort: true,
      formatter: (cell, row) => `${row.sum} ${row.unitsTotal}`,
    },
    {
      dataField: 'unitsTotal',
      text: 'Total Units',
      sort: true,
      hidden: true,
    },
  ];
  function dateFormatter(cell) {
    return moment(cell, 'YYYY-MM-DDTHH:mm:ssZ').format('MM/DD/YYYY HH:mm:ss');
  }
  const defaultSorted = [
    {
      dataField: 'name',
      order: 'desc',
    },
  ];
  const [selected, setSelected] = React.useState({
    key: [],
    row: {},
  });
  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    hideSelectColumn: true,
    style: { backgroundColor: '#007bff80' },
    selected: selected.key,
    onSelect: handleOnSelect,
  };
  function handleOnSelect(row, isSelected) {
    if (isSelected) {
      setSelected({
        key: [row.sensorId],
        row,
      });
    } else {
      setSelected({
        key: [],
        row: {},
      });
    }
  }
  React.useEffect(() => props.onSelectRow(selected), [selected]);
  return (
    <div>
      <h1 className="text-center">
        {props.configure.group.statisticsReportHeading}
      </h1>
      <Datagrid
        datagridProps={{
          keyField: 'sensorId',
          data: props.report.statisticsSummary,
          loading: props.report.isFetching,
          columns,
          defaultSorted,
          selectRow,
        }}
        exportProps={{
          fileName: 'StatisticsDetail-Summary',
        }}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    report: state.report,
    configure: state.configure,
  };
}

export default withTranslation('app')(connect(mapStateToProps, null)(Summary));
